/** @jsxImportSource @emotion/react */

import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import Card from "views/Mission/TeamSpecV2/components/Card";
import { useHistory } from "react-router-dom";
import StatusButton from "views/HomeV2/StatusButton";
import icon from "views/HomeV2/assets/around-the-world.png";

const getCSSRules: CSSRulesResolver = ({ colors }) => ({
  title: {
    fontSize: 24,
    lineHeight: "28.8px",
    fontWeight: 800,
    margin: 0,
  },
  card: {
    border: `1px dashed ${colors.Grey[300]}`,
    "&:hover .linkArrow": {
      opacity: 1,
      transform: "translateX(0px)",
    },

    p: {
      color: colors.Grey[500],
      fontSize: 12,
      lineHeight: "18px",
      fontWeight: 400,
    },
  },
  cardInner: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 8,
    gap: 16,
  },

  titleContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    "@media (max-width: 568px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 16,
    },
  },

  icon: {
    display: "flex",
    width: 75,
    height: 64,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
  },

  col: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
});

const StartAProjectCard = () => {
  const styles = useCSSRulesWithTheme(getCSSRules);
  const history = useHistory();
  const linkHref = `/mission/new`;

  return (
    <Card onClick={() => history.push(linkHref)} css={styles.card}>
      <div css={styles.cardInner}>
        <div css={styles.titleContainer}>
          <div css={styles.col}>
            <div css={styles.row}>
              <img css={styles.icon} src={icon} alt="Role icon" />
            </div>
            <div css={styles.row}>
              <h3 css={styles.title}>Start a new project</h3>
              <p>Publish projects to attract the best talent.</p>
            </div>
          </div>
          <div css={styles.col}>
            <StatusButton startAProject={true} />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default StartAProjectCard;
